import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentVoucher from '../document/DocumentVoucher';


function Vouchers() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="vouchers" parent="5" />
            <HeaderMain slug="vouchers" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentVoucher
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default Vouchers;